import { c as _c } from "react/compiler-runtime";
import { Box, Heading, Link, Stack, Text } from '@chakra-ui/react';
import { ButtonLink, ButtonLinkProps } from '@src/components/sco/ButtonLink.tsx';
import { UserAccessGateProps } from '@src/components/sco/UserAccessGate';
import { LockIcon } from '@src/components/sco/icons';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { usePathname } from 'next/navigation';
import React from 'react';
export const InlineCardCTA = props => {
  const $ = _c(28);
  const pathname = usePathname();
  let t0;
  if ($[0] !== props.boxProps) {
    t0 = props.boxProps || {};
    $[0] = props.boxProps;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["column", "column", "row"];
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = ["center", "center", "left"];
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const t3 = props.title || "Please upgrade to access this item.";
  let t4;
  if ($[4] !== t3) {
    t4 = <Heading flexGrow={1} fontSize="18px">{t3}</Heading>;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== props.subtitle) {
    t5 = props.subtitle && <Text flexGrow={1}>{props.subtitle}</Text>;
    $[6] = props.subtitle;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== pathname || $[9] !== props.hideLoginLink) {
    t6 = !props.hideLoginLink && <Text fontSize="0.8em" marginTop="0.25em" opacity={0.75}>{"Already a member?"}{" "}<Link asChild={true} variant="underline"><NextLink href={`${pathname}?prompt=login`}>Login</NextLink></Link></Text>;
    $[8] = pathname;
    $[9] = props.hideLoginLink;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t4 || $[12] !== t5 || $[13] !== t6) {
    t7 = <Box flexGrow={1}>{t4}{t5}{t6}</Box>;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = ["sm", "md"];
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== props.buttonProps) {
    t9 = props.buttonProps as ButtonLinkProps || {};
    $[16] = props.buttonProps;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <LockIcon />;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  const t11 = props.buttonProps?.children || props.buttonProps?.title || "Upgrade to Unlock";
  let t12;
  if ($[19] !== t11 || $[20] !== t9) {
    t12 = <ButtonLink flexShrink={1} href="#" size={t8} variant="cta" {...t9} asChild={true}>{t10}{t11}</ButtonLink>;
    $[19] = t11;
    $[20] = t9;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== t12 || $[23] !== t7) {
    t13 = <Stack align="center" direction={t1} gap={3} textAlign={t2}>{t7}{t12}</Stack>;
    $[22] = t12;
    $[23] = t7;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t0 || $[26] !== t13) {
    t14 = <Box bgColor="colorPalette.card" border="1px solid" borderColor="colorPalette.border" borderRadius="12px" padding="2em" width="full" {...t0}>{t13}</Box>;
    $[25] = t0;
    $[26] = t13;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  return t14;
};